/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_No_OrdersInputs */

const vi_dashboard_no_orders = /** @type {(inputs: Dashboard_No_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có đơn hàng nào.`)
};

/**

* @param {Dashboard_No_OrdersInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_no_orders = /** @type {((inputs?: Dashboard_No_OrdersInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_No_OrdersInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_no_orders(inputs)
});